/* eslint-disable */
import * as util from "@/api/dashboard";

const state = {
    dataSentMessagesAnnually: {
        "data": [
            {
                "y": "Jan",
                "success": 0,
                "error": 0,
                "pending": 0
            },
            {
                "y": "Feb ",
                "success": 0,
                "error": 0,
                "pending": 0
            },
            {
                "y": "Mar ",
                "success": 0,
                "error": 0,
                "pending": 0
            },
            {
                "y": "Apr ",
                "success": 0,
                "error": 0,
                "pending": 0
            },
            {
                "y": "May ",
                "success": 0,
                "error": 0,
                "pending": 0
            },
            {
                "y": "Jun ",
                "success": 0,
                "error": 0,
                "pending": 0
            },
            {
                "y": "Jul ",
                "success": 0,
                "error": 0,
                "pending": 0
            },
            {
                "y": "Aug ",
                "success": 0,
                "error": 0,
                "pending": 0
            },
            {
                "y": "Sep ",
                "success": 0,
                "error": 0,
                "pending": 0
            },
            {
                "y": "Oct ",
                "success": 0,
                "error": 0,
                "pending": 0
            },
            {
                "y": "Nov ",
                "success": 0,
                "error": 0,
                "pending": 0
            },
            {
                "y": "Dec ",
                "success": 0,
                "error": 0,
                "pending": 0
            }
        ],
        "ykeys": [
            "success",
            "error",
            "pending"
        ],
        "labels": [
            "Success",
            "Error",
            "Pending"
        ],
        "colors": [
            "#55CD62",
            "#fc6075",
            "#D3DCE2"
        ]
    }
};


const mutations = {
    SET_dataSentMessagesAnnually: (state, value) => {
        state.dataSentMessagesAnnually = value
    },
};

const actions = {
    TotalTokenAI({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.TotalTokenAI(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    sentMessagesAnnually({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.sentMessagesAnnually(dataParams).then(response => {
                const { data } = response;
                commit('SET_dataSentMessagesAnnually', data)
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    statAIChat({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.statAIChat(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    statAIChatSummary({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.statAIChatSummary(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    statAIChatBot({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.statAIChatBot(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    waRotator({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.waRotator(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    masterOperator({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.masterOperator(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    contactGroup({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.contactGroup(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    momentSpesial({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.momentSpesial(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
};


export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/dashboard.js